<div fxFlex>
  <as-split 
    gutterSize="5" 
    useTransition="true"
    [disabled]="media.isActive('lt-md')"
    >

    <as-split-area 
      size="50" 
      order="0"
      [visible]="!(media.isActive('lt-md') && (detailData || modifying))" 
      [class.hideList]="(media.isActive('lt-md') && (detailData || modifying))"
      >

      <esc-maintenance-list
        [list]="listData" 
        [columns]="columns"
        [uploadColumns]="excelCols"
        [deselect]="deselect"
        [modifying]="modifying"
        [recordCount]="listLength"
        [loadError]="loading.error" 
        [loading]="loading.init || loading.more"
        [type]="'MNT_AREA'"
        [hasFilter]="true"
        [folderName]="folderName"
        [hasUpload]="true"
        [hasDownload]="true"
        [moduleCode]="'AM'"
        (addNew)="addNew($event)"
        (getMore)="getMore($event)" 
        (refresh)="refresh($event)"
        (searchBy)="searchBy($event)"
        (openFilter)="openFilter($event)"
        (getDetailData)="getDetail($event)" 
        (download)="download($event)"
        >
      </esc-maintenance-list>

      <div *ngIf="loading.init || loading.more" fxLayoutAlign="center center" class="loading-indicator-list" [class.loading-indicator-list-sm]="media.isActive('lt-md')">
        <mat-spinner></mat-spinner>
      </div>
    </as-split-area>

    <as-split-area 
      size="50"
      order="1"
      [visible]="!(media.isActive('lt-md') && !(detailData || modifying))"
      >

      <esc-maintenance-detail
        [detail]="detailData"
        [detailKeys]="detailKeys"
        [loadError]="loading.detailError"
        [moduleCode]="'AM'"
        (edit)="edit($event)"
        (closeDetail)="closeDetail($event)"
        [type]="'LABEL_AREA' | translate"
        *ngIf="!loading.detail && !!detailData && !modifying"
        >
      </esc-maintenance-detail>

      <esc-area-maintenance-form
        [mode]="mode"
        *ngIf="modifying"
        [detail]="detailData"
        (saving)="saving($event)"
        (closeForm)="closeForm($event)"
        >
      </esc-area-maintenance-form>

      <div *ngIf="loading.detail" fxLayoutAlign="center center" class="loading-indicator-detail" [class.loading-indicator-detail-sm]="media.isActive('lt-md')">
        <mat-spinner></mat-spinner>
      </div>
      
      <div *ngIf="!loading.error && !loading.init && !loading.detail && !detailData && !modifying" fxFlexFill fxLayout="column" fxLayoutAlign="center center">
        <mat-icon color="primary" svgIcon="information-outline" class="size-48"></mat-icon>
        <span class="mat-body" [class.compact-header-text]="media.isActive('lt-sm')">
          {{ 'LABEL_NO_SELECTED' | translate}}
        </span>
      </div>
    </as-split-area>
    
  </as-split>
</div>